
const projectsdata = [
  {
    title: 'Upcoming Projects',
    imageWebp : '/assets/project/comingSoon.webp',
    image     : '/assets/project/comingSoon.png',
    description: 'New projects coming soon!',
    demo: 'https://www.youtube.com/@ujwalkt3024',
    repo: 'https://github.com/kt-ujwal',
    openSource: true,
  },

  {
    title: 'Financial Analysis Automation using LLMs',
    imageWebp : '/assets/project/Financial-Analysis.webp',
    image     : '/assets/project/Financial-Analysis.png',
    description:
      'LLM pipeline that structures raw financial data, extracts tickers & sentiment, predicts news impact.',
    demo: 'https://youtu.be/c6mSGPug7GE?si=7IBVb7JfA90plpGf',
    repo: 'https://github.com/kt-ujwal/Financial-Analysis-Automation-using-LLMs',
    openSource: true,
  },

  {
    title: 'AI Answer Engine',
    imageWebp : '/assets/project/AI-Powered-QA-Platform-Design.webp',
    image     : '/assets/project/AI-Powered-QA-Platform-Design.png',
    description:
      'Full-stack Q&A platform (Next.js + RAG) with 40 % higher answer relevance.',
    demo: 'https://youtu.be/V0909IkXu2w?si=5Mu069JjDcCVfG4T',
    repo: 'https://github.com/kt-ujwal/AI-Answer-Engine',
    openSource: true,
  },

  {
    title: 'Pentagram – Stable Diffusion Image Generator',
    imageWebp : '/assets/project/pentagram.webp',
    image     : '/assets/project/pentagram.png',
    description:
      'Cloud-scaled Stable Diffusion finetuned for oil-painting style.',
    demo: 'https://youtu.be/YUbb4vwZ-PQ?si=SPhgV6MHW5eWmyD9',
    repo: 'https://github.com/kt-ujwal/pentagram-stable-diffusion',
    openSource: true,
  },

  {
    title: 'CodeBase RAG',
    imageWebp : '/assets/project/coderag.webp',
    image     : '/assets/project/coderag.png',
    description:
      'Pinecone + OpenAI embeddings search that cuts code lookup time by 80 %.',
    demo: 'https://youtu.be/vtNMftsRfNk?si=s45-iVRDO-KcbUpK',
    repo: 'https://github.com/kt-ujwal/CodeBase-RAG',
    openSource: true,
  },

  {
    title: 'AI Code Assistant (Judge0)',
    imageWebp : '/assets/project/judge0.webp',
    image     : '/assets/project/judge0.png',
    description:
      'LLM code assistant / fixer module merged into Judge0 OSS IDE.',
    demo: 'https://youtu.be/YbTfIEfMvIU?si=3FB5ifdAinqlMxdJ',
    repo: 'https://github.com/kt-ujwal/judge0-ai',
    openSource: true,
  },

  {
    title: 'Bloomberg Financial Anomaly Detection',
    imageWebp : '/assets/project/bloomberg.webp',
    image     : '/assets/project/bloomberg.png',
    description:
      'AI models mining Bloomberg data (2000-2020) for crash prediction.',
    demo: 'https://youtu.be/GMWKbj5-nYU?si=tvT2SDb_6JJWAXho',
    repo: 'https://github.com/kt-ujwal/Bloomberg-Financial-Market-Anomaly-Detection',
    openSource: true,
  },

  {
    title: 'Multi-GPU Parallelism and Training Optimisation in DL Models',
    imageWebp : '/assets/project/highperformance.webp',
    image     : '/assets/project/highperformance.png',
    description:
      'Large-scale recommendation optimisation prototype with 500 ms training speed-up (GPU slicing).',
    demo: '/assets/project/HighPerformance.pdf',
    repo: '',
    openSource: false,
  },

  {
    title: 'AI Ingredient Prediction from Food Images',
    imageWebp : '/assets/project/AI-Nutrition.webp',
    image     : '/assets/project/AI-Nutrition.png',
    description:
      'BERT + InstructBLIP predicts food ingredients from photos (IoU +3 %).',
    demo: '/assets/project/AI_Ingredient.pdf',
    repo: 'https://github.com/kt-ujwal/blip',
    openSource: true,
  },

  {
    title: 'VLM Evaluation Suite',
    imageWebp : '/assets/project/vlm.webp',
    image     : '/assets/project/vlm.png',
    description:
      'Benchmarks InstructBLIP-FLAN-T5 & CLIP on CIDEr / SPIDEr caption metrics.',
    demo: '/assets/project/vlm.pdf',
    repo: '',
    openSource: false,
  },

  {
    title: 'GNN Anatomy – Multi-Level Explainability',
    imageWebp : '/assets/project/GNNAnatomy.webp',
    image     : '/assets/project/GNNAnatomy.png',
    description:
      'GNNAnatomy: Systematic generation & evaluation of multi-level explanations for GNNs.',
    demo: 'https://arxiv.org/abs/2406.04548',
    repo: '',
    openSource: false,
  },

  {
    title: 'Other Cool Projects',
    imageWebp : '/assets/project/coolest-projects.webp',
    image     : '/assets/project/coolest-projects.png',
    description: 'A smorgasbord of side quests & weekend hacks.',
    demo: 'https://www.youtube.com/@ujwalkt3024',
    repo: 'https://github.com/kt-ujwal',
    openSource: true,
  },
];

export default projectsdata;